<template>
  <div class="home-page">
    <div class="pc">
      <img src="@/assets/img/home/baner1.png" alt="" srcset="" @load="getImg" />
      <transition
        enter-active-class="animate__animated animate__bounceInDown"
        leave-active-class=""
      >
        <img
          v-show="imgIsOver"
          class="text-img"
          src="@/assets/img/home/text.png"
          alt=""
          srcset=""
          @load="getImg"
        />
      </transition>
      <transition
        enter-active-class="animate__animated animate__bounceInDown"
        leave-active-class=""
      >
        <router-link
          v-show="imgIsOver"
          class="product"
          :to="{
            path: '/productIndex',
            query: { childrenIndex: '1-1', cabinetIndex: '0' },
          }"
          >了解产品</router-link
        >
      </transition>
      <transition
        enter-active-class="animate__animated animate__bounceInDown"
        leave-active-class=""
      >
        <router-link v-show="imgIsOver" class="cooperation" to="/about"
          >公司简介</router-link
        >
      </transition>
    </div>
    <div class="mobile">
      <img src="@/assets/img/home/mbaner.png" alt="" srcset="" @load="getImg" />
      <div class="content-wrap">
        <img
          class="text-img"
          src="@/assets/img/home/mtext.png"
          alt=""
          srcset=""
          @load="getImg"
        />
        <div class="text-wrap">
          <div>末端交付</div>
          <div>存储管理</div>
          <div>租赁贩卖</div>
        </div>
        <div class="btn-wrap">
          <router-link
            v-show="imgIsOver"
            class="product"
            :to="{
              path: '/productIndex',
              query: { childrenIndex: '1-1', cabinetIndex: '0' },
            }"
            >了解产品</router-link
          >
          <router-link v-show="imgIsOver" class="cooperation" to="/about"
            >公司简介</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgIsOver: false,
    };
  },
  methods: {
    getImg() {
      setTimeout(() => {
        this.imgIsOver = true;
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 480px) {
  .home-page {
    width: 100%;
    position: relative;
    .mobile {
      display: none;
    }
    img {
      width: 100%;
      height: auto;
    }
    .product,
    .cooperation {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 57.35%;
      width: 160rem;
      min-width: 60px;
      height: 68rem;
      min-height: 18px;
      border-radius: 100rem;
      font-size: 20rem;
      color: #fff;
      cursor: pointer;
      -webkit-user-select: none; /* Chrome, Safari, Opera */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
    }
    .product {
      left: 8.49%;
      background: #ffc733;
      border: 2rem solid #ffc733;
      box-shadow: 0rem 14rem 34rem rgba(254, 89, 85, 0.24);
    }
    .cooperation {
      left: calc(8.49% + 58px + 160rem);
      background: #426cbf;
      border: 2rem solid #426cbf;
      box-shadow: 0rem 14rem 34rem rgba(69, 54, 178, 0.24);
    }
    .text-img {
      position: absolute;
      top: 27.89%;
      left: 8.49%;
      width: 538rem;
      height: auto;
    }
  }
}
@media screen and (max-width: 480px) {
  .home-page {
    width: 100%;
    position: relative;
    .pc {
      display: none;
    }
    img {
      width: 100%;
      height: auto;
    }
    .content-wrap {
      padding: 43px 0 100px;
      .text-img {
        margin: 0 auto 18px;
        width: 198px;
        height: auto;
      }
      .text-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 17px;
        div {
          &:nth-child(2) {
            margin: 0 20px;
          }
        }
      }
      .btn-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 29px 0 0;
        .product,
        .cooperation {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          width: 76px;
          height: 33px;
          background: #ffc733;
          border: 2px solid #ffc733;
          box-shadow: 0px 14px 34px rgba(255, 199, 51, 0.24);
          border-radius: 100px;
          font-weight: 700;
          font-size: 12px;
          color: #030303;
        }
        .cooperation {
          background: #426cbf;
          border: 2px solid #426cbf;
          box-shadow: 0px 14px 34px rgba(66, 108, 191, 0.24);
          color: #fff;
          margin-left: 46px;
        }
      }
    }
  }
}
</style>
